import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { BmiBreadcrumb } from "../components/BmiBreadcrumb";
import { BmiCalc } from "../components/BmiCalc";
import { BmiExplainer } from "../components/BmiExplainer";
import { BmiRelated } from "../components/BmiRelated";

export function BmiHub() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <BmiBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.bmi_hub_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.bmi_hub_intro()}
          </p>
        </header>

        <BmiCalc />

        <BmiRelated />

        <BmiExplainer
          howTo={m.bmi_hub_howto()}
          faqs={[
            { q: m.bmi_hub_faq1_q(), a: m.bmi_hub_faq1_a() },
            { q: m.bmi_hub_faq2_q(), a: m.bmi_hub_faq2_a() },
            { q: m.bmi_hub_faq3_q(), a: m.bmi_hub_faq3_a() },
            { q: m.bmi_hub_faq4_q(), a: m.bmi_hub_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
